import React from 'react';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Input, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  all_sponsors: '',
};

const App = props => {
  const { titleWidth, disabled, checkSubChange, changeData, data } = props;
  const ary = data.sub1 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub1', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  const renderAry = [];
  for (let i = 0; i < ary.length; i++) {
    const isFirst = i === 0;
    renderAry.push(
      <EAA_Row key={`Page_Contract_sub1_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} text={isFirst ? '全體發起人' : ''} bol={isFirst} haveChange={checkSubChange(1, [emptyBody])} />
            <EAA_Input displayBorder disabled={disabled} value={ary[i].all_sponsors} onChange={data => { ary[i].all_sponsors = data; saveSub(ary); }} />
          </EAA_ItemContainer>
        </EAA_Item>
        <EAA_Item>
          <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
        </EAA_Item>
      </EAA_Row>,
    );
  }
  return renderAry;
};
export default App;
